import React from 'react'
import routes from '../../RootRoutes'
import { Home } from '../../container'
import { Routes, Route, useLocation} from 'react-router-dom'
import {AnimatePresence} from 'framer-motion'

function AnimatedRoutes() {
    const location = useLocation()

  return (
      <AnimatePresence>
        <Routes location={location} key={location.pathname}>

            <Route
            path='/'
            element={<Home />}
            /> 

                {routes.map((item, i) => (
                <Route
                key={i}
                path={item.path}
                element={item.component}
                /> 
                ))} 
    
        </Routes>
    </AnimatePresence>
  )
}

export default AnimatedRoutes